import React, { Component } from 'react';
import { Grid, IconButton } from '@material-ui/core';
import HistoricalOrdersCnn from '../Home/connected/HistoricalOrdersCnn';
import { withRouter, RouteComponentProps } from 'react-router';
import RBACCnn from '../Auth/connected/RBACCnn';
import LogoAndTitle from '../Layout/components/LogoAndTitle';
import { ArrowBack } from '@material-ui/icons';

type Props = RouteComponentProps<any>

class HistoricalOrdersView extends Component<Props> {
    render() {
        return (
            <RBACCnn for="Restaurant">
                <Grid container alignItems="center">
                    <Grid item sm={1} style={{ textAlign: 'center' }}>
                        <IconButton size="medium" onClick={() => this.props.history.push('/')}><ArrowBack fontSize="large" /></IconButton>
                    </Grid>
                    <Grid item sm={11}>
                        <LogoAndTitle title="Your historical orders" />
                    </Grid>
                </Grid>

                <Grid container alignContent="center">
                    <Grid item xs={12} sm={12} >
                        <HistoricalOrdersCnn mode="browser" />
                    </Grid>
                </Grid>
            </RBACCnn>
        );
    }
}

export default withRouter(HistoricalOrdersView);